export const blockIconsHardwareLaptopMacNew = (
	<span className='material-symbols-outlined'>laptop_mac</span>
);
